var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagUyu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 18C0 19.4726 1.194 20.6666 2.66667 20.6666H21.3333C22.806 20.6666 24 19.4726 24 18V17.3333H0V18ZM0 12.6666H24V15.3333H0V12.6666Z",
    fill: "#0038A8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.3334H24V17.3334H0V15.3334Z",
    fill: "#EEEEEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 6.00004C24 4.52737 22.806 3.33337 21.3333 3.33337H10.6667V6.00004H24ZM10.6667 8.00004H24V10.6667H10.6667V8.00004Z",
    fill: "#0038A8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 6.00004V3.33337H2.66667C1.194 3.33337 0 4.52737 0 6.00004V12.6667H24V10.6667H10.6667V8.00004H24V6.00004H10.6667Z",
    fill: "#EEEEEE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66667 7.99996C8.66667 6.15863 7.17467 4.66663 5.33333 4.66663C3.492 4.66663 2 6.15929 2 7.99996C2 9.84063 3.49267 11.3333 5.33333 11.3333C7.17467 11.3333 8.66667 9.84063 8.66667 7.99996Z",
    fill: "#FFD983"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99999 8.00004C7.99999 6.52737 6.80666 5.33337 5.33332 5.33337C3.86066 5.33337 2.66666 6.52737 2.66666 8.00004C2.66666 9.47204 3.86066 10.6667 5.33332 10.6667C6.80666 10.6667 7.99999 9.47204 7.99999 8.00004Z",
    fill: "#FFCC4D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 3.73132L5.75533 6.42532L7.468 4.30332L6.486 6.84732L9.03 5.86532L6.908 7.57799L9.602 7.99999L6.908 8.42199L9.03 10.1347L6.486 9.15266L7.468 11.6967L5.75533 9.57466L5.33333 12.2687L4.91133 9.57466L3.19867 11.6967L4.18067 9.15266L1.63667 10.1347L3.75867 8.42199L1.06467 7.99999L3.75867 7.57799L1.63667 5.86532L4.18067 6.84732L3.19867 4.30332L4.91133 6.42532L5.33333 3.73132Z",
    fill: "#FFAC33"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33334 8C7.33334 6.89533 6.43801 6 5.33334 6C4.22868 6 3.33334 6.89533 3.33334 8C3.33334 9.104 4.22868 10 5.33334 10C6.43801 10 7.33334 9.104 7.33334 8Z",
    fill: "#C1694F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.88934 8.00265C3.88934 7.20932 4.53201 6.56665 5.32468 6.56665C6.11734 6.56665 6.76001 7.20932 6.76001 8.00265C6.76001 8.79532 6.11734 9.43732 5.32468 9.43732C4.53201 9.43732 3.88934 8.79465 3.88934 8.00265Z",
    fill: "#FFAC33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagUyu);
export default __webpack_public_path__ + "static/media/flag-uyu.4e7f3f95662f2d91596dbdf6008fc537.svg";
export { ForwardRef as ReactComponent };